<template>
<p>{{$tf('expire_session.message',{count})}}</p>
</template>

<script>
import bus from '~/bus'
import { dialogExpireSessionDuration } from '~/main.js'
export default {
  name: 'DialogExpireSession',
  data: () => ({
    count: dialogExpireSessionDuration,
    startingCount: dialogExpireSessionDuration
  }),
  mounted () {
    bus.$on('continue-session', this.continueSession)
    this.countDown = setInterval(async () => {
      this.count--
      if (this.count < 1 && this.$idle.idle) {
        this.$store.dispatch('dialog/clearQueue')
        this.$store.dispatch('dialog/closeDialog')

        await this.$store.dispatch('session/destroyGuestSession').catch(err => { console.debug(err) })
        if (this.$store.getters['session/isAuthenticated']) {
          await this.$store.dispatch('session/destroySession').catch(err => { console.debug(err) })
          sessionStorage.setItem('expiration_logout', 'expired')
          window.location.reload()
        } else {
          await this.$store.dispatch('session/logout').catch(err => { console.debug(err) })
          this.$router.push(this.$config.defaultMagicLinkURL)
        }

        clearInterval(this.countDown)
        console.log(this.$tf('expire_session.logged_out.log', {count: this.$config.expireSessionTime}))
        this.$store.dispatch('dialog/showDialog', {
          title: this.$tf('expire_session.logged_out.title'),
          body: this.$tf('expire_session.logged_out.message'),
          persistent: false,
          width: 480,
          actions: {
            accept: {
              title: 'Close'
            }
          }
        })
      }
      if (this.count < 0) {
        this.count = this.startingCount
        clearInterval(this.countDown)
      }
    }, 1000)
  },
  methods: {
    continueSession () {
      this.$store.dispatch('dialog/closeDialog')
      clearInterval(this.countDown)
      this.count = this.startingCount
    }
  },
  beforeDestroy () {
    bus.$off('continue-session', this.continueSession)
  }
}
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// src/components/common/dialog/types/DialogExpireSession.vue